import React from "react";
import tw from "twin.macro";

import styles from "../Components/MiscStyles/customcss.module.css";
import { PrimaryButton, Link2 } from "../Components/MiscStyles/Buttons";

const Container = tw.div`relative md:mb-0 mb-80`;
const ImageContainer = tw.div`relative`;

const Header = tw.div`h-90 bg-secondary relative`;
const HeaderContent = tw.div`text-white absolute bottom-0  md:mx-72 mx-10  pb-10 text-4xl`;

const Content = tw.div`md:flex flex-wrap justify-center md:mx-32 mt-20`;
const CardContainer = tw.div`md:w-3/12 mx-6 my-10 border border-gray-400 border-opacity-30`;
const DescriptionContainer = tw.div`absolute bottom-0 w-full p-4 bg-white cursor-pointer`;

const ButtonContainer = tw.div`flex justify-center mt-10 mb-28`;

const LeftContainer = tw.div` relative overflow-hidden`;

const Heading = tw.h2`text-xl  `;
const Subheading = tw.h5`text-xs text-gray-500  `;

const HeaderHeading = tw.h2`text-3xl  font-playfair`;
const HeaderParagraph = tw.h5`text-smm my-2 w-3/4`;

export default () => {
  return (
    <Container>
      <Header>
        <HeaderContent>
          <HeaderHeading>PROJECTS</HeaderHeading>
          <HeaderParagraph>
            SEE BELOW TO HAVE A GREATER UNDERSTANDING OF OUR PREVIOUS
            EXPERIENCES, WHERE WE ARE GOING AND WHAT WE HOLD IMPORTANT TO US AS
            A COMPANY
          </HeaderParagraph>
        </HeaderContent>
      </Header>
      <Content>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.one}`}></div>
            <div class="image-overlay">
              <div class="image-text">Hello World</div>
            </div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.two}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>FCC</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.three}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>HOGAN LOVELLS</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.four}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>ABT ASSOCIATES</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.five}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>MORGAN LEWIS</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.six}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.one}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.two}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.three}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.four}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.five}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
        <CardContainer>
          <LeftContainer>
            <div className={`${styles.leftimage} ${styles.six}`}></div>
            <DescriptionContainer>
              <Subheading>NEW YORK</Subheading>
              <Heading>Avenue Capital Group</Heading>
            </DescriptionContainer>
          </LeftContainer>
        </CardContainer>
      </Content>
      <ButtonContainer>
        <PrimaryButton href="/ContactUs">GET IN TOUCH</PrimaryButton>
      </ButtonContainer>
    </Container>
  );
};
